import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function History() {
  const [history, setHistory] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchHistory() {
      try {
        setLoading(true);
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/user/history/${user.email}`);
        const data = await res.json();
        
        if (Array.isArray(data)) {
          setHistory(data);
        } else if (data.quizHistory && Array.isArray(data.quizHistory)) {
          setHistory(data.quizHistory);
        } else {
          setHistory([]); 
          console.warn("History data is not an array:", data);
        }
      } catch (err) {
        console.error("Failed to fetch history:", err);
        setHistory([]);
      }finally {
        setLoading(false);
      }
    }

    fetchHistory();
  }, [user.email]);

  return (
    <div className="container mt-3">
      <h2 >Your Quiz History</h2>
      {loading ? (
          <div className="text-center mt-4">
            <div className="spinner-border text-primary" role="status"></div>
            <p className="mt-2 text-muted">Loading quiz history...</p>
          </div>
        ) : history.length === 0 ? (
          <p>No quizzes attempted yet.</p>
        ) : (
        history.map((quiz, idx) => (
          <div key={idx} className="card m-3 p-3 shadow-sm">
            <h4 >{quiz.quizName}</h4>
            <p>Marks: {quiz.totalMarks}</p>
            <p>Date: {quiz.date ? new Date(quiz.date).toLocaleString() : "N/A"}</p>

            <button
              className="btn btn-sm btn-primary"
              onClick={() =>
                navigate(`/user/history/quiz/${quiz.quizNumber}`, {
                  state: { quiz }, 
                })
              }
            >
              View Details
            </button>
          </div>
        ))
      )}
    </div>
  );
}

export default History;
